import React, {Component} from 'react';
import {connect} from 'react-redux';
import {path} from 'ramda';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {changeModalState} from '../../actions/modal'
import {validateFields} from "../../utils/validate";
import {
  mergeDeepLeft,
  clone,
} from 'ramda';
import { AsyncCreatable } from 'react-select';
import './style.css';


class SendEmailPopup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      wrapClassName: 'modal-default modal-tagging',
      size: 'lg',
      fields: clone({
        recipients: {
          label: 'Recipients',
          placeholder: 'Select recipients',
          system: {
            name: 'recipients',
          },
          value: [],
          errors: [],
          type: 'text',
          name: 'recipients',
          rules: {
            title: 'Recipients field',
            required: true
          }
        },
      }),
    };

    this.toggle = this.toggle.bind(this);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.getSelectedValues = this.getSelectedValues.bind(this);
    this.isValidNewOption = this.isValidNewOption.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const selectedItems = path(['modal', 'selectedItems'], newProps);
    const contactsList = path(['modal', 'recipients'], newProps);
    let stateClone = clone(this.state);

    stateClone.fields['recipients'].value = [];
    if (contactsList && selectedItems && selectedItems.length > 0 && contactsList.length > 0) {
      selectedItems.forEach((selectedId) => {
        contactsList.forEach((contact) => {
          if (contact.value === selectedId) {
            stateClone.fields['recipients'].value.push({value: selectedId, label: contact.name});
          }
        })
      });
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  toggle() {
    this.setState({sending: false});
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen
    });
  }

  cancel() {
    this.toggle();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields['recipients'].value = field;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const id = path(['modal', 'id'], this.props);
      let handler = path(['modal', 'handler'], this.props);
      let recipients = [];
      if (result.fields['recipients'].value && result.fields['recipients'].value.length > 0) {
        result.fields['recipients'].value.forEach((recipient) => {
          recipients.push(recipient.value);
        });
        this.props.makeActionById({id: id, recipients: recipients}, handler);
      }

      this.toggle();
    }
    return false;
  }

  loadOptions() {
    const contactsList = path(['modal', 'recipients'], this.props);
    return new Promise((resolve, reject) => {
      let options = [];
      if (contactsList && contactsList.length > 0) {
        contactsList.forEach((contact) => {
          options.push({value: contact.value, label: contact.name});
        });
      }
      resolve({options: options});
    });
  }

  getSelectedValues() {
    return this.state.fields['recipients'].value;
  }

  isValidNewOption(option) {
    if (option && option.label) {
      return option.label.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    } else {
      return false;
    }
  }

  render() {
    let modalId = path(['modal', 'modalId'], this.props);

    let showModal = this.props.modal.isOpen;
    if (modalId && modalId !== this.props.id) {
      showModal = false;
    }

    const formatCreateLabel = (inputValue) => `Send To ${inputValue}`;

    return (
      <Modal
        isOpen={showModal}
        toggle={this.toggle}
        wrapClassName={this.state.wrapClassName}
        size={this.state.size}
      >

        <ModalHeader>Please select recipients</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={this.submit}>
              <div className={'form-group recipients-select-control'}>
                <AsyncCreatable
                  disabled={false}
                  cacheOptions
                  defaultOptions
                  multi={true}
                  clearable={false}
                  placeholder='Choose recipients...'
                  loadOptions={this.loadOptions}
                  onChange={this.changeFormValue }
                  value={ this.getSelectedValues() }
                  isValidNewOption={this.isValidNewOption}
                  formatCreateLabel={formatCreateLabel}
                />
              </div>
            </form>
          </div>
          <div className="clearfix pull-right">
            <button className="btn btn-default mr-1" onClick={this.cancel}>
              Cancel
            </button>
            <button className="btn btn-default" onClick={this.submit} disabled={this.state.fields['recipients'].value.length === 0}>
              Send
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    makeActionById: (data, handler) => {
      if (typeof handler(data) == 'function') {
        handler(data)(dispatch);
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmailPopup);



// WEBPACK FOOTER //
// ./src/containers/QuotesEdit/sendEmailPopup.js